import { useMemo } from 'react';
import * as R from 'remeda';
import { OwnPropsOfRenderer } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { commonDataGridStyles } from '@rossum/components/data-grid/styles';
import { Box } from '@rossum/ui/material';
import { DataGridPro, GridColDef } from '@rossum/ui/x-data-grid-pro';

type TableControlProps = {
  data: Array<Record<string, string>>;
} & OwnPropsOfRenderer;

export const TableControl = withJsonFormsControlProps(
  ({ data, uischema }: TableControlProps) => {
    const columns = useMemo<GridColDef[]>(() => {
      const first = data[0];
      return first
        ? Object.keys(R.omit(first, ['id'])).map(key => ({
            field: key,
            flex: 1,
          }))
        : [];
    }, [data]);

    return (
      <Box
        sx={{
          position: 'relative',
          height: 600,
          width: 1,
          py: 1,
          px: 2,
        }}
      >
        <DataGridPro
          disableRowSelectionExcludeModel
          columns={columns}
          rows={data}
          sx={{
            '&': {
              '--DataGrid-pinnedBackground': t => t.palette.background.paper,
              '--DataGrid-containerBackground': t => t.palette.background.paper,
            },
            ...commonDataGridStyles,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            ...uischema?.options?.['sx'],
          }}
          disableColumnSelector
          disableColumnPinning
          disableRowSelectionOnClick
          {...uischema?.options}
        />
      </Box>
    );
  }
);
